import React from 'react';

interface GlobalLoaderProps {
  isLoading: boolean;
  message?: string;
  subMessage?: string;
}

const GlobalLoader: React.FC<GlobalLoaderProps> = ({ 
  isLoading, 
  message = "Processing Please wait...", 
  subMessage = "Please wait while we process your request" 
}) => {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-xl p-8 flex flex-col items-center gap-4 shadow-xl w-80 mx-4">
        {/* Courier-RX Logo */}
        <div className="w-16 h-16 bg-green-600 rounded-xl flex items-center justify-center animate-pulse">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        {/* App Name */}
        <div className="text-xl font-semibold text-gray-800">Courier-RX</div>
        
        {/* Loading Message */}
        <p className="text-sm text-gray-600 text-center">{message}</p>
        <p className="text-xs text-gray-500 text-center">{subMessage}</p>
        
        {/* Spinner */}
        <div className="w-6 h-6 border-2 border-gray-200 border-t-green-600 rounded-full animate-spin"></div>
      </div>
    </div>
  );
};

export default GlobalLoader;
